import React, {Component} from 'react';
import PropTypes from 'prop-types';

import connect from "react-redux/es/connect/connect";
import {__} from "i18n-for-browser";
import TaxItem from "./TaxItemMain";
import Calculator from "../../assets/img/icons/L-belasting-1.svg";
import {ministryIcons} from "../../assets/assets";
import VerliesGlobas from "../../assets/img/icons/economy/min-globas.svg";
import WinstGlobas from "../../assets/img/icons/economy/up-globas.svg";
import actions from "../../actions";
import Scrollbar from 'react-scrollbars-custom';
import {
  getText,
  getImageText,
  getImage,
  getPoints,
  calculateDebitCreditOutcomeBasic
} from "../../helpers/feedbackHelpers";
import NextStep from "../elements/NextStep";

const { submitMyState } = actions.gameStateInput;

class TaxesLow extends Component {
  static propTypes = {
    inheritedState: PropTypes.object.isRequired,
  };
  static defaultProps = {
    desktop: false
  };
  constructor (props) {
    super(props);
    this.state = {
      showReceivedInterestDropdown: false,
      showPaidInterestDropdown: false,
      showOtherIncomeDropdown: false,
      showBudgetDropdown: false,
    };
  }

  componentWillReceiveProps() {
    // In this nasty hack, we fake a second tax step like we have in the PRO version.
    // When the first tax step is processed, we dispatch the second (empty) step.
    const { myState } = this.props.gameStateInput;
    if (myState.SIMULATION_TAX === 'PROCESSED') {
      this.props.dispatch(submitMyState('SIMULATION_TAX_2'));
    }
  };

  getWinstVerliesEffect = fb => ({
    icon: parseInt(fb.winstverliesglobas, 10) >= 0 ? WinstGlobas : VerliesGlobas,
    title: parseInt(fb.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas'),
    contentTitle: fb.winstverliesglobas || 0,
    contentUnit: __('sim_miljard'),
  });

  getEffects = fb => {
    const effects = [];
    if (fb.economie) {
      effects.push(this.getWinstVerliesEffect(fb.economie));
    }
    return effects.concat((fb.overigeEffecten || []).map((oe) => ({
      icon: ministryIcons[oe.ministerie],
      title: __(oe.ministerie),
      contentTitle: getPoints(oe),
      contentUnit: __('sim_punten'),
    })));
  };

  render() {
    const { gameState, gameStateInput, feedback } = this.props;
    const { myState } = gameStateInput;
    const { gameStateSum } = gameState.roundData;
    const { belastingFeedback } = feedback;

    let isBankDisabledForSimulation = false;
    if (myState && myState.SIMULATION_TAX === 'PROCESSED') {
      const currDC = gameState.roundData && gameState.roundData.lastGameState && gameState.roundData.lastGameState.OneTimeEffect && gameState.roundData.lastGameState.OneTimeEffect.debitCredit;
      isBankDisabledForSimulation = currDC ? currDC.some(c => c.bankDisabledPayout) : false;
    } else {
      isBankDisabledForSimulation = this.props.project.bankEnabled === false;
    }

    let schuld = this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.find(i => i.key === 'lenenVanBank');
    let spaargeld = this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.find(i => i.key === 'stortenSpaargeld');
    if(schuld) schuld = calculateDebitCreditOutcomeBasic(schuld, isBankDisabledForSimulation);
    if(spaargeld) spaargeld = calculateDebitCreditOutcomeBasic(spaargeld, isBankDisabledForSimulation);
    if (!schuld) schuld = {};
    if (!spaargeld) spaargeld = {};
    spaargeld.amount = -spaargeld.amount || 0;
    schuld.amount = -schuld.amount || 0;
    return (
      <div className={'darkBckg'}>
        <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
        <div className='container taxes'>
          <div className={'taxes-section'}>
            <TaxItem
              history={this.props.history}
              title={__('sim_belastinginkomsten')}
              video={'https://player.vimeo.com/video/265045525'}
              reverseGlobasPoints={true}
              sliderKey={'arbeidsBelasting'}
              points={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_points}
              globas={myState.SIMULATION_TAX !== 'PROCESSED' ? '-' : gameStateSum.AB_globas}
              twoValueSlider={true}
              suffix={'%'}
              sliderTitles={[__('sim_belasting'), __('sim_bevolking')]}
              maxValue={100}
              cap={79}
              minValue={0}
              capNotification={__('sim_basic_arbeidsbelasting_te_hoog_percentage_melding')}
              sliderValue={myState.arbeidsBelasting}
              notification={{
                read: belastingFeedback.read,
                reference: belastingFeedback.id,
              }}
              icon={Calculator}
              taxDescription={__('sim_basic_arbeidsbelasting_beschrijving')}
              feedbackData={{
                show: myState.SIMULATION_TAX === 'PROCESSED',
                topData: [],
                img: getImage(belastingFeedback),
                imgDescription: getImageText(belastingFeedback, gameState.language),
                description: getText(belastingFeedback, gameState.language),
                effects: this.getEffects(belastingFeedback),
              }}
              popupId={'dlgvtbelasting'}
              ignorePopup={true}
              showDropdown={this.props.paramsTaxId === 'belasting'}
            />
          </div>
        </div>
        </Scrollbar>
        <NextStep />
      </div>
    )
  }
}

export default connect(({gameState, feedback, gameStateInput, project, schoolClass}) => ({gameState, feedback, gameStateInput, project, schoolClass}))(TaxesLow);



// WEBPACK FOOTER //
// ./src/components/desktop/TaxesLowMain.js